<!-- @format -->

<order-list>
  <table class="contents_table">
    <tbody>
      <tr class="column_orders-crocodesk">
        <th class="date">
          <div class="sort-cel">
            お申込日
            <div
              if="{ props.orderBy }"
              class="{ props.orderBy == 'asc' ? 'button_sort-ascend' : 'button_sort-descend' }"
              onclick="{ e => props.setOrderBy(props.orderBy == 'asc' ? 'desc' : 'asc') }"
            ></div>
          </div>
        </th>
        <th class="order-id">注文ID</th>
        <th class="order-detail">注文名</th>
        <th class="person">担当者</th>
        <th class="price">金額（税込）</th>
        <th class="status">ステータス</th>
      </tr>

      <tr each="{ order in props.list }">
        <td><span class="date">{order.ordered_date}</span></td>
        <td><a class="order-id" href="{order.detail_link}" target="_blank">{ order.id }</a></td>
        <td>{ order.name }</td>
        <td>{ order.staff||'-' }</td>
        <td>{ Number(order.price).toLocaleString() }円</td>
        <td><span class="{OrderStatus(order.status).class}">{OrderStatus(order.status).text}</span></td>
      </tr>
    </tbody>
  </table>
  <!--/.contents_table-->

  <script>
    import Status from "@model/status.js";
    export default {
      OrderStatus: Status.order,
      detail(e, order) {
        window.open(order.detail_link, `order-${order.id}`);
      },
    };
  </script>
</order-list>
